import request from "@/utils/request";

export default function agentGetChargeTimeConf(params) {
    return request({
        url: `/device/chargeTimeConf/agentGetGroupTimeConf`,
        params
    })
}
